var exports = {
  "X7": "UserProfileBadges.module__containerModal___Vl96S3",
  "j4": "UserProfileBadges.module__containerModalMobile___Vl96S3",
  "pP": "UserProfileBadges.module__containerModalDesktop___Vl96S3",
  "Ub": "UserProfileBadges.module__pending___Vl96S3",
  "RS": "UserProfileBadges.module__containerPopout___Vl96S3",
  "Qk": "UserProfileBadges.module__badgeMobile___Vl96S3",
  "EJ": "UserProfileBadges.module__badgeDesktop___Vl96S3",
  "SI": "UserProfileBadges.module__captionBadge___Vl96S3",
  "Kd": "UserProfileBadges.module__captionBadgeMobile___Vl96S3",
  "eA": "UserProfileBadges.module__captionBadgeDesktop___Vl96S3",
  "nf": "UserProfileBadges.module__link___Vl96S3",
  "$J": "UserProfileBadges.module__linkButton___Vl96S3",
  "zH": "UserProfileBadges.module__details___Vl96S3",
  "i5": "UserProfileBadges.module__detailsArt___Vl96S3",
  "x2": "UserProfileBadges.module__detailsTitle___Vl96S3",
  "L4": "UserProfileBadges.module__detailsLine___Vl96S3",
  "r9": "UserProfileBadges.module__editButton___Vl96S3",
  "IZ": "UserProfileBadges.module__editIcon___Vl96S3",
  "Mj": "UserProfileBadges.module__moreButton___Vl96S3",
  "CG": "UserProfileBadges.module__moreButtonDesktop___Vl96S3",
  "mL": "UserProfileBadges.module__moreButtonMobile___Vl96S3",
};

module.exports = exports;
